/** Stable logical identities for this capability's owned fixed UDO templates. */
export enum OttokartCustomerEngagementWorkspaceCapabilityUdoTemplateKey {
    categoryRequest = "d392aae1-d36a-4d8c-b65b-1362fa658829",
    fleetProfile = "553f5feb-5dfd-4f97-a8a7-6eb2a38b6c5d",
    fleetStatusLog = "b912333b-f709-4531-84cf-b46ed116ec72",
    preference = "579a87e9-318b-44ab-ba04-3797bbeabd4f",
    recentlyViewed = "f518504c-1394-492e-9570-50584f3b5da9",
    cartItem = "b9106efe-b10e-4346-b92b-dbbd719f78ba",
}
